import { MouseEvent, useCallback, useState } from 'react';
import { trackEvent } from '~/adapters/tracking/tracking';
import { OrderSummary } from '~/adapters/services/accounts/orders/types';
import { useOrderDetails } from '~/adapters/services/accounts/orders/hooks';
import { useMobileBreakpoint, Box } from '@customink/pigment-react';
import { DesktopOrderContentRow } from './DesktopOrderContentRow/DesktopOrderContentRow';
import { MobileOrderContentRow } from './MobileOrderContentRow/MobileOrderContentRow';

interface Props {
    order: OrderSummary;
    singleDetail: boolean;
}

export function OrderCard({ order, singleDetail }: Props) {
    const [open, setOpen] = useState(false);
    const { data, isLoading } = useOrderDetails({ orderId: order.id }, { enabled: open });

    const isMobile = useMobileBreakpoint();

    const toggleDetail = useCallback(
        (e: MouseEvent<HTMLElement>): void => {
            e.preventDefault();
            if (!open) {
                trackEvent({ action: 'accounts order', label: 'details' });
            }
            setOpen(!open);
        },
        [open],
    );

    return (
        <Box data-testid="order history card">
            {isMobile ? (
                <MobileOrderContentRow
                    order={order}
                    detailOpen={open}
                    toggle={toggleDetail}
                    singleDetail={singleDetail}
                    isLoading={isLoading}
                    data={data}
                    open={open}
                />
            ) : (
                <DesktopOrderContentRow
                    order={order}
                    detailOpen={open}
                    toggle={toggleDetail}
                    singleDetail={singleDetail}
                    isLoading={isLoading}
                    data={data}
                    open={open}
                />
            )}
        </Box>
    );
}
